import { bn } from 'tools/math';
import { formatFiat } from 'utils/formats/formatFiat';

export const formatPairTooltipVolume = (volume: number, symbol: string) =>
  formatFiat(bn(volume), 18, symbol);
